var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertebostik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alertebostik") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e30040",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M31.2 16c0 8.395-6.805 15.2-15.2 15.2s-15.2-6.805-15.2-15.2c0-8.395 6.805-15.2 15.2-15.2s15.2 6.805 15.2 15.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e30040",
    d: "M14.223 9.76h3.571l-0.595 8.774h-2.381l-0.595-8.774zM16.009 23.354c-0.525 0-0.966-0.166-1.325-0.499-0.346-0.346-0.518-0.762-0.518-1.248s0.173-0.89 0.518-1.21c0.346-0.333 0.787-0.499 1.325-0.499s0.979 0.166 1.325 0.499c0.346 0.32 0.518 0.723 0.518 1.21s-0.179 0.902-0.538 1.248c-0.346 0.333-0.781 0.499-1.306 0.499z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertebostik);
export default __webpack_public_path__ + "static/media/alertebostik.4f3f66404126bf92c130ad53900d860e.svg";
export { ForwardRef as ReactComponent };